module.exports = __webpack_public_path__ + "img/light.e765f4e4.svg";